import { styled, Typography } from '@mui/joy';

import { TAB_FULL_WIDTH } from 'theme/constants';

export const SubtitleLabelWrapper = styled(Typography)({
  fontWeight: 500,
});

export const SubtitleValueWrapper = styled(Typography)(({ theme }) => ({
  color: theme.palette.neutral[800],
  fontWeight: 600,
}));

export const baseInfoWrapperStyle = {
  ['@media (min-width: 1440px)']: {
    width: 1272,
  },

  ['@media (max-width: 1440px)']: {
    width: TAB_FULL_WIDTH,
  },
};
